import { useEffect } from "react";
import { useUser } from "@clerk/nextjs";
import InputWrapper from "../InputWrapper/InputWrapper";

export default function EmailInput({
  id,
  label,
  defaultValue,
  register,
  formState,
  attributes,
  useFormMethods,
  wrapperProps,
}) {
  const { errors } = formState;

  const { isSignedIn, isLoaded, user } = useUser();

  const autoFillValue =
    isSignedIn && isLoaded ? user?.primaryEmailAddress?.emailAddress : null;

  // Depend on setValue itself, not the useFormMethods object: FormContainer
  // rebuilds that object every render, so depending on it re-fires this effect
  // on every render, and setValue triggers the next one.
  const setValue = useFormMethods?.setValue;

  useEffect(() => {
    if (defaultValue || (autoFillValue && setValue)) {
      setValue(id, autoFillValue);
    }
  }, [defaultValue, autoFillValue, id, setValue]);

  if (!id || !label || !register || !formState) {
    return <p>Could not load this field</p>;
  }

  return (
    <InputWrapper label={label} id={id} formState={formState} {...wrapperProps}>
      <input
        type="email"
        id={id}
        name={id}
        defaultValue={defaultValue ?? autoFillValue}
        className={`textInput`}
        {...attributes}
        {...register(id, {
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Invalid email address",
          },
        })}
        aria-invalid={errors[id] ? "true" : "false"}
      />
    </InputWrapper>
  );
}
